import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService, environment, MyHttpClientFactory } from '@ups/xplat/core';
import { MaterialWarehouse } from '../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaterialWarehouseService extends DataService<MaterialWarehouse> {
  route: string;

  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.toolTrackerAPI,
      '/api/MaterialWarehouse',
      httpClient,
      httpFactory
    );
  }

  getByFacilityId(facilityKeyId: number): Observable<MaterialWarehouse[]> {
    return this.httpClient.get<MaterialWarehouse[]>(
      `${this.route}/${facilityKeyId}`
    );
  }
}
